<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'SocialRespCenter',
            to: {
              name: 'SocialRespCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'SocialRespCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增社會責任</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增社會責任 -->
    <SocialRespCreateEdit></SocialRespCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SocialRespCreateEdit from '@/views/B-11__SOCIALRESP/c/SocialRespCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SocialRespCreateEdit,
  },
  computed: {
    ...mapState('socialresponsibility', ['socialresponsibility']),
  },
  created() {
    this.setSocialresponsibility({});
  },
  methods: {
    ...mapActions('socialresponsibility', ['setSocialresponsibility', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'SocialRespCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.socialresponsibility.title) {
          this.errors.push('標題 required.');
        }/* else if (!this.socialresponsibility.slug) {
          this.errors.push('Slug required.');
        } */
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.socialresponsibility).then(() => {
          this.$router.push({ name: 'SocialRespCenter' });
        });
      }
    },
  },
};
</script>
<style></style>
